<template>
  <div class="container">
    <div class="row">
      <div class="col col-8 offset-1">
        <h2 class="text-center">Share Poster</h2>
        <form id="contact_form" action="">
          <div class="form-group">
            <label for="name">Your name:*</label>
            <input v-model="name" class="form-control" name="name" required type="text"/>
          </div>
          <div class="form-group">
            <label for="email">Your Email:*</label>
            <input v-model="email" class="form-control" name="email" required type="email"/>
          </div>
          <div class="form-group">
            <label for="message">Message
              <small>(<span>{{ message.length }}</span> / <span>{{ maxLength }}</span>)</small>
            </label>
            <textarea v-model="message" class="form-control" name="message" :maxlength="maxLength"></textarea>
          </div>
          <p class="alert alert-warning" v-show="errorMessage.length > 0" v-html="errorMessage"></p>
          <button type="submit" class="btn btn-primary">Send</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Share",
        data: function () {
            return {
                name: '',   // data for the name on the form
                email: '',   // data for the email on the form
                message: '', // data for the message on the form
                maxLength: 2500, // maximum length of the form message
                posterID: this.$route.params.id,
                errorMessage: ''// message to show the user if there is an error
            }
        },
    }
</script>

<style scoped>

</style>